<!-- ── Row summary ─────────────────────────────────────────────────────── -->
<div class="file-row" [class.file-row--expanded]="isExpanded">
  <div class="file-row__summary" (click)="toggleExpanded()">
    <div class="file-row__cell file-row__cell--checkbox" (click)="$event.stopPropagation()">
      <ui-checkbox
        [checked]="selected"
        [ariaLabel]="'common.select' | translate"
        (changed)="selectionChange.emit($event)"
      ></ui-checkbox>
    </div>
    <div class="file-row__cell file-row__cell--name">
      {{ document.fileName }}
    </div>
    <div class="file-row__cell file-row__cell--type">
      <span class="file-row__type-badge">{{ "knowledge_base.filter_type." + document.type | translate }}</span>
    </div>
    <div class="file-row__cell file-row__cell--status">
      <span class="file-row__status-badge" [ngClass]="statusBadgeClass">
        {{ document.status | titlecase }}
      </span>
    </div>
    <div class="file-row__cell file-row__cell--date">
      {{ document.uploadDate | adaptToUserUtcOffset | date: DATE_TIME_FORMAT }}
      <ui-button
        type="secondary"
        [icon]="isExpanded ? 'chevron-up' : 'chevron-down'"
        (click)="toggleExpanded(); $event.stopPropagation()"
      ></ui-button>
    </div>
  </div>

  <!-- ── Expanded panel ─────────────────────────────────────────────────── -->
  <div class="file-row__details" *ngIf="isExpanded">
    <!-- AI overview -->
    <div class="file-row__ai-overview" *ngIf="document.aiOverview">
      <div class="file-row__detail-label">
        <ui-svg-icon svgIcon="ai-volta-icon" size="medium"></ui-svg-icon>
        {{ "knowledge_base.ai_overview" | translate }}
      </div>
      <p class="file-row__ai-overview-text">{{ document.aiOverview }}</p>
      <button class="file-row__refresh-btn" [attr.aria-label]="'knowledge_base.refresh_overview' | translate">
        <ui-svg-icon svgIcon="refresh" size="medium"></ui-svg-icon>
      </button>
    </div>

    <!-- Internal notes -->
    <div class="file-row__internal-notes">
      <div class="file-row__detail-label">
        {{ "knowledge_base.internal_notes" | translate }}
      </div>
      <textarea
        class="file-row__notes-input"
        [placeholder]="'knowledge_base.internal_notes_placeholder' | translate"
        [(ngModel)]="editableNotes"
        [disabled]="!(canEditKnowledgeBase$ | async)"
        (blur)="onNotesBlur()"
        rows="2"
      ></textarea>
    </div>

    <!-- Tags -->
    <div class="file-row__tags" *ngIf="document.tags?.length">
      <div class="file-row__detail-label">
        <ui-svg-icon svgIcon="tag" size="medium"></ui-svg-icon>
        {{ "knowledge_base.tags" | translate }}:
      </div>
      <div class="file-row__tags-list">
        <span class="file-row__tag" *ngFor="let tag of document.tags">
          {{ tag }}
          <ui-svg-icon
            *appHasPermission="{ module: 'knowledge_base', action: 'edit' }"
            class="file-row__tag-remove"
            svgIcon="close"
            size="medium"
            (click)="onRemoveTag(tag)"
          ></ui-svg-icon>
        </span>
      </div>
    </div>

    <hr class="separator" />

    <!-- Action buttons -->
    <div class="file-row__action-buttons">
      <ui-button
        *appHasPermission="{ module: 'knowledge_base', action: 'delete' }"
        [label]="'knowledge_base.delete' | translate"
        type="danger"
        icon="trash-cc"
        (click)="onDelete()"
      ></ui-button>
      <ui-button
        *appHasPermission="{ module: 'knowledge_base', action: 'edit' }"
        [label]="'knowledge_base.replace' | translate"
        type="secondary"
        icon="repeat"
        (click)="onEdit()"
      ></ui-button>
    </div>
  </div>
</div>
